module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-st.316c9340.png";